<template>
  <form @submit.prevent="submit" :class="errorClass">
    <h2 class="login-title">Welcome back!</h2>
    <div class="login-header">Please login so you can continue</div>
    <rp-textinput
      v-model="resource.email"
      placeholder="Email address"
      :error="emailError"
      isRequired
      @input="touch('email')"/>

    <rp-password
      v-model="resource.password"
      placeholder="Password"
      :error="passwordError"
      isRequired
      @input="touch('password')"/>

    <div class="password-reset-link">
      <router-link :to="{ name: 'Reset Password Login Email' }">
        I forgot my password
      </router-link>
    </div>

    <rp-button :disabled="isInvalid" type="primary">Log in</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'
  import TextInput from '../../../components/ui/inputs/TextInput'

  export default {
    name: 'LoginForm',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-password': Password,
      'rp-textinput': TextInput
    },

    computed: {
      ...errorMessages(['email', 'password'])
    },

    validations: {
      resource: {
        email: {required, email},
        password: {required}
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  .password-reset-link
    font-size: 14px
    text-align: right
    a
      font-weight: bold

  .login-header
    font-size: 1.6rem
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/Login_v2.vue